export default "__VITE_ASSET__BgdShsSi__"